import type { CourseSiteBrand } from "@bodemleven/course-kit/react";

export const brand: CourseSiteBrand = {
  name: "Bodemleven",
  tagline: { nl: "Bodemonderzoek", en: "Soil research" },
  logoSrc: "/logo-mark.svg",
  homeUrl: "https://bodemleven.com",
};
